module.exports = __webpack_public_path__ + "img/aCourse.7949cfd7.png";